class Viewport {
  constructor() {
    this.top = 0;
    this.bottom = 200;
    this.left = 0;
    this.right = 1000;
  }
}
module.exports = Viewport;